import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Buefy from 'buefy'
import Meta from 'vue-meta'
import lineClamp from 'vue-line-clamp'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters'
import './registerServiceWorker'
import 'babel-polyfill'

Vue.use(VueAxios, axios)
Vue.use(Meta)
Vue.use(Buefy)
Vue.use(filters)
Vue.use(lineClamp)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered'))
}).$mount('#app')
